var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 395,
    height: 344,
    viewBox: "0 0 395 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M177.166 0L393.528 124.884L393.496 293.494L177.135 168.61L177.166 0Z",
    fill: "url(#paint0_linear_2_14009)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M177.17 0L393.248 124.727V147.596L177.17 22.8693V0Z",
    fill: "url(#paint1_linear_2_14009)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.238 75.7693L184.169 108.044V123.553L128.238 91.2776V75.7693Z",
    fill: "#474552"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M310.955 162.854L366.886 195.128V210.637L310.955 178.362V162.854Z",
    fill: "#474552"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M274.279 183.741L383.435 246.749V293.589L274.279 230.581V183.741Z",
    fill: "url(#paint2_linear_2_14009)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M284.846 178.456L394.002 241.464V288.304L284.846 225.295V178.456Z",
    fill: "url(#paint3_linear_2_14009)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M282.359 197.928L298.811 207.428V222.936L282.359 213.436V197.928Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M302.619 210.165L319.071 219.665V235.173L302.619 225.673V210.165Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M322.877 221.646L339.329 231.147V246.655L322.877 237.123V221.646Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M343.139 233.883L359.591 243.383V258.892L343.139 249.392V233.883Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M191.764 63.3862L315.893 135.045V140.33L191.764 68.7025V63.3862Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M200.697 25.0084C200.697 28.4372 198.684 30.0415 196.231 28.626C193.777 27.2104 191.764 23.2783 191.764 19.8809C191.764 16.4836 193.777 14.8478 196.231 16.2634C198.684 17.6789 200.697 21.6111 200.697 25.0084Z",
    fill: "#D00E2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M197.113 99.8499L260.96 136.688V254.973L197.113 218.135V99.8499Z",
    fill: "url(#paint4_linear_2_14009)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M203.398 170.059L254.674 199.659V204.84L203.398 175.24V170.059Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M206.979 182.211L251.054 207.658V212.839L206.979 187.392V182.211Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M225.606 203.392L181.188 177.754V190.973L225.606 216.611V203.392Z",
    fill: "#474552"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M236.308 146.326C236.308 152.04 232.994 154.745 228.918 152.383C224.842 150.021 221.527 143.43 221.527 137.678C221.527 131.964 224.842 129.259 228.918 131.621C232.994 134.059 236.308 140.611 236.308 146.326Z",
    fill: "#D00E2E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M228.921 156.993C222.331 153.145 216.883 156.764 215.931 165.031C215.778 166.478 216.845 168.383 218.178 169.145L239.664 181.716C240.997 182.478 242.064 181.869 241.911 180.23C240.959 170.821 235.511 160.84 228.921 156.993Z",
    fill: "#D00E2E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M197.486 222.42L282.902 271.745L282.93 316.276L205.037 271.314L197.515 273.784L197.486 222.42Z",
    fill: "url(#paint5_linear_2_14009)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M258.064 279.583V267.496L290.307 286.1V298.188L258.064 279.583Z",
    fill: "#D00E2E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M219.447 245.015L238.167 255.81V259.715L219.447 248.92V245.015Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M219.447 253.772L253.24 273.267V277.171L219.447 257.705V253.772Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M219.447 261.61L263.174 286.847V290.752L219.447 265.515V261.61Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M214.831 247.37C214.831 251.045 212.649 252.767 209.979 251.217C207.309 249.667 205.127 245.446 205.127 241.771C205.127 238.096 207.309 236.373 209.979 237.924C212.678 239.474 214.831 243.695 214.831 247.37Z",
    fill: "#D00E2E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M75.2629 325.103C85.5751 341.509 99.8443 343.665 100.444 343.785C101.883 344.024 102.722 342.707 102.722 340.791V297.438C102.722 282.708 107.758 273.247 117.711 269.175C118.67 268.816 119.27 267.738 119.27 266.301C119.27 245.463 118.91 156.004 118.79 128.1C118.79 123.43 115.552 117.921 111.595 115.645C90.2516 103.31 28.9781 67.9817 28.9781 67.9817C12.6705 58.5208 2.23846 64.3889 0.439827 83.7897L0.319878 169.656C0.319878 182.71 2.59818 196.123 9.79271 207.261C13.8696 213.608 18.6659 218.518 23.7021 221.392L65.5504 245.463V285.702C65.4304 301.51 68.7879 314.684 75.2629 325.103Z",
    fill: "url(#paint6_linear_2_14009)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M174.676 303.077L128.237 276.209V123.838L174.676 150.706V303.077Z",
    fill: "#D00E2E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_14009",
    x1: 327.496,
    y1: 104.689,
    x2: 246.806,
    y2: 185.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_14009",
    x1: 230.782,
    y1: -18.3947,
    x2: 312.828,
    y2: 120.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_14009",
    x1: 338.993,
    y1: 221.107,
    x2: 320.312,
    y2: 253.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_14009",
    x1: 349.569,
    y1: 215.818,
    x2: 330.888,
    y2: 248.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_14009",
    x1: 267.798,
    y1: 110.258,
    x2: 211.125,
    y2: 208.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_14009",
    x1: 234.176,
    y1: 223.87,
    x2: 245.221,
    y2: 313.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_14009",
    x1: 104.078,
    y1: 220.836,
    x2: -46.1271,
    y2: 163.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.5e78f09a331e18fd0fed84bb55fb03bf.svg";
export { ForwardRef as ReactComponent };